export default "__VITE_ASSET__TvFpoK4F__"